import { handleCancelEditionPanel } from '@features/divisions/containers/SingleDivisionContainer/SingleDivisionContainer.handlers';
import { FormType } from '@features/divisions/containers/SingleDivisionContainer/SingleDivisionContainer.types';
import { DivisionEditionFormType } from '@features/divisions/interfaces/division-edition.interface';
import ProcessCreationFormType from '@features/processes/interfaces/process-creation.interface';
import { ProcessEditionFormType } from '@features/processes/interfaces/process-edition.interface';
import { DivisionCliente, ProcesoDivision } from '@interfaces/firestore-documents.interfaces';
import { RequestFn } from '@interfaces/requests.interfaces';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';
import { ChangeEventHandler, Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';

export function handleProcessNameChange(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onChange: (...event: any[]) => void
): ChangeEventHandler<HTMLInputElement> {
	return function (e) {
		const { value } = e.target;

		// Colocamos la primera letra del nombre en mayúscula.
		onChange(value && value.length > 0 ? value[0].toUpperCase() + value.slice(1, 100) : '');
	};
}

export function handleSaveProcessCreationData(
	divisionData: DivisionCliente,
	divisionEditionForm: UseFormReturn<DivisionEditionFormType>,
	enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
	nit: string,
	processCreationForm: UseFormReturn<ProcessCreationFormType>,
	processEditionForm: UseFormReturn<ProcessEditionFormType>,
	requestBackendSuite: RequestFn,
	setAfterSaveOnBeforeCloseDialogAction: Dispatch<SetStateAction<(() => void) | null>>,
	setBeforeCloseDialog: Dispatch<SetStateAction<boolean>>,
	setBeforeSaveData: Dispatch<SetStateAction<ProcessEditionFormType | null>>,
	setBeforeSaveDialog: Dispatch<SetStateAction<string>>,
	setEditionProcessData: Dispatch<SetStateAction<ProcesoDivision | null>>,
	setForm: Dispatch<SetStateAction<FormType>>,
	setShow: React.Dispatch<React.SetStateAction<boolean>>,
	getDataById: (identificacion: string) => Promise<void>
): () => Promise<void> {
	return processCreationForm.handleSubmit(async (data) => {
		try {
			setShow(true);
			// Guardamos los datos generales del proceso.
			const response = (await requestBackendSuite('procesos', 'POST', {
				identificacion: nit,
				codigo_div: divisionData.codigo_div,
				proceso: {
					cliente_genera_numeracion: data.cliente_genera_numeracion ?? true,
					flag_referencia_unica: data.referencia_detalle_unica ?? true,
					combos_asociados:
						data.combos_asociados.length > 0 ? data.combos_asociados : undefined,
					consecutivo_actual: data.cliente_genera_numeracion
						? undefined
						: data.consecutivo_actual,
					consecutivo_desde: data.consecutivo_desde,
					consecutivo_hasta: data.consecutivo_hasta,
					cotizador: data.cotizador ?? false,
					liquidacion_en_despacho: data.liquidacion_en_despacho ?? false,
					liquidacion_en_guia: data.liquidacion_en_guia ?? false,
					nombre_proceso: data.nombre_proceso,
					// notificacion_destinatario: data.notificacion_destinatario ?? false,
					prefijo_consecutivo: data.prefijo_consecutivo?.toString(),
					servicios_asociados:
						data.servicios_asociados.length > 0 ? data.servicios_asociados : undefined,
					topic_push: data.topic_push.length > 0 ? data.topic_push : null,
					nombre_rango: data.nombre,
					telefono_rango: data.telefono,
					direccion_rango: data.direccion,
					ciudad_rango: data.ciudad,
					nombre_ciudad_rango: data.nombre_ciudad,
					correo_rango: data.correo,
				},
			})) as any;

			if (response.isError) {
				throw new Error(response.message);
			}

			handleCancelEditionPanel(
				null,
				divisionData,
				divisionEditionForm,
				processCreationForm,
				processEditionForm,
				setAfterSaveOnBeforeCloseDialogAction,
				setBeforeCloseDialog,
				setBeforeSaveData,
				setBeforeSaveDialog,
				setEditionProcessData,
				setForm
			)();
			await getDataById(nit);
			setShow(false);
			document.getElementById(`process-${response.data?.id_proceso || ''}`)?.scrollIntoView();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setShow(false);
			if (typeof error === 'string') {
				enqueueSnackbar(error, { variant: 'error' });
			} else if (error.response && error.response.data.message) {
				enqueueSnackbar(error.response.data.message, { variant: 'error' });
			}
		}
	});
}
